// extracted by mini-css-extract-plugin
export var linkText = "_qh-0";